import styled from 'styled-components'

interface IUserSelectStyledProps {}

export const UserSelectStyled = styled.div<IUserSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
